import { render, staticRenderFns } from "./SystemMaintenance.vue?vue&type=template&id=72147f7e&scoped=true"
var script = {}
import style0 from "./SystemMaintenance.vue?vue&type=style&index=0&id=72147f7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72147f7e",
  null
  
)

export default component.exports